"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const select_1 = tslib_1.__importDefault(require("antd/es/select"));
exports.Select = (_a) => {
    var { className = '', dropdownClassName = '', bordered = 'full', width = 'auto' } = _a, props = tslib_1.__rest(_a, ["className", "dropdownClassName", "bordered", "width"]);
    const borderedClass = bordered === 'bottom' ? 'clp-select_bordered_bottom' : '';
    const widthClass = width === 'auto' ? '' : `clp-select_width_${width}`;
    return (React.createElement(select_1.default, Object.assign({ dropdownClassName: `clp-select__dropdown ${dropdownClassName}`, className: `clp-select ${borderedClass} ${widthClass} ${className}` }, props)));
};
//# sourceMappingURL=Select.js.map